// extracted by mini-css-extract-plugin
export default {"placeholder":"_9DOO4ntDdANCFZI9UJ3UUA=="};